import React, { useState, useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchPropertyCounts,
  clearCountsDone,
  deleteProperty,
} from 'src/store/actions/properties';
import { CSVLink } from 'react-csv';
import { getPropertyBuildings } from 'src/store/actions/buildings';
import { PATHS } from 'src/common/constants';
import { selectPropertyById } from 'src/store/selectors/properties';
import {
  setPropertyFormData,
  clearPropertyFormData,
} from 'src/store/actions/propertyForm';
import Avatar from '../../components/Avatar';
import Breadcrumb from '../../components/Breadcrumb';
import Button from '../../components/Button';
import Card from '../../components/Card';
import HeadingWithDetails from '../../components/HeadingWithDetails';
import FontAwesomeIcon from '../../components/Icon';
import Loader from '../../components/Loader';
import Metrics from '../../components/Metrics';
import Overlay from '../../components/Overlay';
import PropertyDocuments from './PropertyDocuments';
import PropertyForm from '../../components/PropertyForm';
import PropertyNotes from './PropertyNotes';
import PropertyServiceRequests from './PropertyServiceRequests';
import PropertySuites from './PropertySuites';
import PropertyCommonAreas from './PropertyCommonAreas';
import PropertyDevelopers from 'src/pages/Property/PropertyDevelopers/PropertyDevelopers';
import Empty from '../../components/Empty';
import Tabs from '../../components/Tabs';
import Tenant from '../../components/Tenant';
import WithNavigation from '../../layouts/WithNavigation';
import {
  fetchFaqsNotesDocuments,
  clearNotes,
} from 'src/store/actions/faqsNotesDocuments';
import { upload } from 'src/helpers/upLoadHelper';
import { updateProperty } from 'src/store/actions/properties';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { clearServiceRequests } from 'src/store/actions/serviceRequests';
import { getWalkthroughSuites } from 'src/store/actions/WalkthroughSuites';
import { selectCounts } from 'src/store/selectors/Counts';
import { Colors, variables } from 'src/Tenants';
import { checkSparkDataAvailable } from 'src/helpers/validationHelper';
import { getSuiteOnBoardingConveyanceFormListByPropertyCSV } from 'src/store/actions/Property';
import { onRequestPhoneCall } from 'src/helpers/validationHelper';
import {
  fetchtAllowedTabList,
  setSelectedModulePermission,
} from 'src/store/actions/tabSelections';
import { clearActiveSuiteTab } from 'src/store/actions/activeTab';
import { BrandingContext } from 'src/branding/BrandingContextProvider';
import ReusableLightbox from 'src/components/ReusableLightbox/reusable-lightbox';
import 'react-image-lightbox/style.css';
import { PropertyRequestDataProvider } from './Context/PropertyContext';

let headers = [
  { label: 'Law Firm Notary', key: 'lawFirmNotary' },
  {
    label: 'Legal Representative Contact Name',
    key: 'lawyerNotaryContactName',
  },
  { label: 'Legal Representative Mailing Address', key: 'mailingAddress' },
  { label: 'Legal Representative Phone', key: 'phone' },
  { label: 'Legal Representative Email', key: 'email' },
  { label: 'Legal Representative Fax', key: 'fax' },
  { label: 'Financial Institution Bank', key: 'financialInstitutionBank' },
  { label: 'Property Name', key: 'propertyName' },
  { label: 'Suite Name', key: 'suiteName' },
  { label: 'Strata Lot', key: 'stratalot' },
  { label: 'Home Owner', key: 'homeOwner' },
  { label: 'Date', key: 'dateTime' },
];

interface PropertyProps {
  match: {
    params: {
      id: any;
    };
  };
  location: {
    state?: {
      data: {
        serviceRequestId?: any;
      };
    };
  };
  history: any;
}

const Property = (props: PropertyProps) => {
  const dispatch = useDispatch();

  const user = useSelector((state: any) => selectAuthenticatedUser(state));
  const property = useSelector((state: any) =>
    selectPropertyById(state, props.match.params.id)
  );
  const counts = useSelector((state: any) => selectCounts(state));
  const propertyCSV = useSelector((state: any) => state.Property.payload);
  const tabList = useSelector((state: any) => state.tabSelections.tabList);
  const notesList = useSelector((state: any) => state.notes);

  const [state, setState] = useState({
    showOverlay: false,
    isOpen: false,
    count: true,
  });

  const { branding } = useContext(BrandingContext);

  const onFetchFaqsNotesDocuments = (propertyId: any) =>
    dispatch(fetchFaqsNotesDocuments(propertyId));
  const onSetPropertyFromData = (data: any) =>
    dispatch(setPropertyFormData(data));
  const onClearPropertyFormData = () => dispatch(clearPropertyFormData());
  const onUpdateProperty = (params: any) => dispatch(updateProperty(params));
  const onDeleteProperty = (id: any, userId: any, history: any) =>
    dispatch(deleteProperty(id, userId, history));
  const clearServiceRequestsAction = () => dispatch(clearServiceRequests());
  const getWalkthroughSuitesAction = (propertyId: any) =>
    dispatch(getWalkthroughSuites(propertyId));
  const onFetchPropertyCounts = (propertyId: any, userId: any, roleName: any) =>
    dispatch(fetchPropertyCounts(propertyId, userId, roleName));
  const clearCountsDoneAction = () => dispatch(clearCountsDone());
  const getPropertyBuildingsAction = (propertyId: any) =>
    dispatch(getPropertyBuildings(propertyId));
  const getSuiteOnBoardingConveyanceFormListByPropertyCSVAction = (
    propertyId: any
  ) => dispatch(getSuiteOnBoardingConveyanceFormListByPropertyCSV(propertyId));
  const setSelectedModulePermissionAction = (permissions: any) =>
    dispatch(setSelectedModulePermission(permissions));
  const fetchtAllowedTabListAction = (propertyId: any) =>
    dispatch(fetchtAllowedTabList(propertyId));
  const clearActiveSuiteTabAction = () => dispatch(clearActiveSuiteTab());
  const clearNotesAction = () => dispatch(clearNotes());

  useEffect(() => {
    const componentDidMountLogic = async () => {
      clearNotesAction();
      await onFetchFaqsNotesDocuments(property.propertyId);
      clearCountsDoneAction();
      fetchtAllowedTabListAction(property.propertyId);
      onFetchPropertyCounts(
        property.propertyId,
        user.id,
        user.roles[0].role.name
      );
      downloadConveyanceFormList();
      clearServiceRequestsAction();
      if (property && property.propertyId) {
        getWalkthroughSuitesAction(property.propertyId);
      }
      getPropertyBuildingsAction(property.propertyId);
    };

    if (property && user && user.roles && user.roles[0] && user.roles[0].role) {
      componentDidMountLogic();
    }
  }, [property, user]);

  useEffect(() => {
    return () => {
      clearActiveSuiteTabAction();
    };
  }, []);

  const onSaveProperty = async (data: any) => {
    let params: any = {};

    let imageUrl = null;
    if (data.selectedImage && data.selectedImage.length > 0) {
      imageUrl = await upload(data.selectedImage[0]);
    }

    let stages =
      data.constructionStages && data.constructionStages.length > 0
        ? data.constructionStages.filter((cs: any) => !cs.new)
        : [];

    if (data.propertyId) {
      params = {
        id: data.propertyId,
        propertyId: data.propertyId,
        name: data.name,
        addressLine1: data.addressLine1,
        addressLine2: '',
        city: data.city,
        province: data.province,
        postalCode: data.postalCode,
        latitude: '17.5896',
        longitude: '17.556896',
        image: imageUrl != null ? imageUrl : data.image,
        UserId: user.id,
        PropertyManagerId:
          data.propertyManager && data.propertyManager.id
            ? data.propertyManager.id
            : data.propertyManagerId,
        StrataManagerId: data.strataManagerId
          ? data.strataManagerId
          : data.strataManager && data.strataManager.id
            ? data.strataManager.id
            : null,
        ConstructionStages: stages,
        modulePermissions: data.modulePermissions || [],
      };

      onUpdateProperty(params);
    }
  };

  const handleClosePropertyForm = () => {
    setState({ ...state, showOverlay: false });
    onClearPropertyFormData();
  };

  const deletePropertyFromAPI = (data: any) => {
    onDeleteProperty(data.id, user.id, props.history);
  };

  const downloadConveyanceFormList = () => {
    getSuiteOnBoardingConveyanceFormListByPropertyCSVAction(
      property.propertyId
    );
  };

  const onSetPropertFormDataCall = (data: any) => {
    onSetPropertyFromData(data);
    let ModulePermissions: any[] = [];
    if (data.modulePermissions !== null) {
      ModulePermissions = data.modulePermissions.map((item: any) => {
        return { Id: item.id };
      });
    }
    setSelectedModulePermissionAction(ModulePermissions);
  };

  var HmeOwnrOcpntRltrNotes: any[] = [];
  var noteVisibleToHomeownerOccupantRealtor = false;

  if (
    notesList !== undefined &&
    notesList != null &&
    notesList !== '' &&
    notesList.length > 0
  ) {
    let notes = notesList.filter((x: any) => x.type == 'NOTES');
    if (notes.length > 0) {
      notes.forEach((object: any) => {
        HmeOwnrOcpntRltrNotes.push(
          JSON.parse(JSON.parse(JSON.stringify(object.data)))
        );
      });
    }
    if (HmeOwnrOcpntRltrNotes.length > 0) {
      let filterNotes = HmeOwnrOcpntRltrNotes.filter(
        (x: any) => x.noteVisibleToHomeownerOccupantRealtor == true
      );
      if (filterNotes.length > 0) {
        noteVisibleToHomeownerOccupantRealtor = true;
      }
    }
  }

  const serviceRequestId =
    props.location.state && props.location.state.data.serviceRequestId
      ? props.location.state.data.serviceRequestId
      : null;
  let homeOwnerCheck =
    user &&
    user.roles &&
    user.roles.length > 0 &&
    user.roles[0].role.name === 'Home Owner';
  let { isOpen } = state;
  const { showOverlay } = state;
  let linkView = false;
  if (
    user.roles[0].role.name === 'Admin' ||
    user.roles[0].role.name === 'Property Developer' ||
    user.roles[0].role.name === 'Strata Manager'
  ) {
    linkView = true;
  }

  if (property && property.id) {
    return (
      <PropertyRequestDataProvider>
        <WithNavigation
          title={property.name}
          top={
            <HeadingWithDetails
              style={{
                backgroundImage: `url(/assets/banner-property.png)`,
              }}
              breadcrumb={
                serviceRequestId !== null ? (
                  <Breadcrumb
                    to={PATHS.SERVICE_REQUESTS_VIEW.replace(
                      ':id',
                      serviceRequestId
                    )}
                    label="Service Request"
                  />
                ) : (
                  <Breadcrumb to={PATHS.PROPERTIES_LIST} label="Properties" />
                )
              }
              headline={property.name}
              items={[
                <Card
                  body={
                    <>
                      {property.addressLine1}
                      <br />
                      {property.city}, {property.province}
                      <br />
                      {property.postalCode}
                    </>
                  }
                />,
                <Metrics
                  title="Overview"
                  items={[
                    {
                      key: variables.suiteName,
                      value: counts.suitesCount ? counts.suitesCount : 0,
                    },
                    {
                      key: variables.homeOwners,
                      value: counts.homeOwnersCount
                        ? counts.homeOwnersCount
                        : 0,
                    },
                    {
                      key: branding?.text?.serviceRequest,
                      value: counts.serviceRequestsCount
                        ? counts.serviceRequestsCount
                        : 0,
                    },
                  ]}
                />,
                <Card
                  title={'Primary ' + variables.propertyDeveloper}
                  body={
                    property.propertyManager &&
                    property.propertyManager.firstname ? (
                      <Tenant
                        headline={
                          linkView === true ? (
                            <a
                              href={PATHS.CONTACTS_VIEW.replace(
                                ':id',
                                property.propertyManager.id
                              )}
                            >
                              {property.propertyManager.firstname}{' '}
                              {property.propertyManager.lastname}
                            </a>
                          ) : (
                            property.propertyManager.firstname +
                            '' +
                            property.propertyManager.lastname
                          )
                        }
                        strapline={''}
                        avatar={
                          <div
                            onClick={() =>
                              setState({
                                ...state,
                                isOpen: !!property.propertyManager.profileImage,
                              })
                            }
                          >
                            <Avatar
                              badge="property-manager"
                              url={property.propertyManager.profileImage}
                            />
                            {isOpen && isOpen === true ? (
                              <ReusableLightbox
                                isOpen={state.isOpen}
                                onClose={() =>
                                  setState({ ...state, isOpen: false })
                                }
                                image={property.propertyManager.profileImage}
                              />
                            ) : null}
                          </div>
                        }
                      />
                    ) : (
                      <div style={{ textAlign: 'center' }}>Unassigned</div>
                    )
                  }
                />,
                <Card
                  title="Strata Manager"
                  body={
                    property.strataManager &&
                    property.strataManager.firstname ? (
                      <Tenant
                        headline={
                          linkView === true ? (
                            <a
                              href={PATHS.CONTACTS_VIEW.replace(
                                ':id',
                                property.strataManager.id
                              )}
                            >
                              {property.strataManager.firstname}{' '}
                              {property.strataManager.lastname}
                            </a>
                          ) : (
                            property.strataManager.firstname +
                            ' ' +
                            property.strataManager.lastname
                          )
                        }
                        strapline={onRequestPhoneCall(
                          property.strataManager.phone
                        )}
                        avatar={
                          <div
                            onClick={() =>
                              setState({
                                ...state,
                                isOpen: !!property.strataManager.profileImage,
                              })
                            }
                          >
                            <Avatar
                              badge="strata-manager"
                              url={property.strataManager.profileImage}
                            />
                            {isOpen && isOpen === true ? (
                              <ReusableLightbox
                                isOpen={state.isOpen}
                                onClose={() =>
                                  setState({ ...state, isOpen: false })
                                }
                                image={property.strataManager.profileImage}
                              />
                            ) : null}
                          </div>
                        }
                      />
                    ) : (
                      <div style={{ textAlign: 'center' }}>Unassigned</div>
                    )
                  }
                />,
              ]}
              actions={
                checkSparkDataAvailable(property, user.roles[0].role.name) ||
                homeOwnerCheck ||
                user.roles[0].role.name === 'Occupant' ? null : (
                  <>
                    <Button
                      color="semantic"
                      onClick={() => {
                        setState({ ...state, showOverlay: true });
                        onSetPropertFormDataCall(property);
                      }}
                      label={<FontAwesomeIcon glyph="pencil" weight="light" />}
                    />
                    {user.roles[0].role.name === 'Admin' ||
                    user.roles[0].role.name === 'Super Admin' ? (
                      <Button
                        color="semantic"
                        onClick={() =>
                          window.confirm(
                            `Are you sure you want to delete ${property.name}?`
                          ) && deletePropertyFromAPI(property)
                        }
                        label={<FontAwesomeIcon glyph="trash" weight="light" />}
                      />
                    ) : null}
                    <Overlay
                      showOverlay={showOverlay}
                      content={
                        <PropertyForm
                          onClose={handleClosePropertyForm}
                          tabList={tabList}
                          onSaveProperty={(data: any) => onSaveProperty(data)}
                        />
                      }
                    />
                  </>
                )
              }
            />
          }
          bottom={
            <Tabs
              from={'Property'}
              items={[
                {
                  label: variables.suiteName,
                  count: counts.suitesCount
                    ? counts.suitesCount.toString()
                    : '0',
                  content: <PropertySuites property={property} />,
                },
                {
                  label: branding?.text?.serviceRequest + 's',
                  count: counts.serviceRequestsCount
                    ? counts.serviceRequestsCount.toString()
                    : '0',
                  content: <PropertyServiceRequests property={property} />,
                },
                {
                  label: 'Manuals & Documents',
                  count: counts.documentsCount
                    ? counts.documentsCount.toString()
                    : '0',
                  content: <PropertyDocuments property={property} />,
                },
                {
                  label: 'Common Areas',
                  count: counts.commonAreasCount
                    ? counts.commonAreasCount
                    : '0',
                  content: <PropertyCommonAreas property={property} />,
                },
                (homeOwnerCheck ||
                  user.roles[0].role.name === 'Occupant' ||
                  user.roles[0].role.name === 'Realtor') &&
                noteVisibleToHomeownerOccupantRealtor == false
                  ? {}
                  : {
                      label: 'Notes',
                      count: counts.notesCount
                        ? counts.notesCount.toString()
                        : '0',
                      content: <PropertyNotes property={property} />,
                    },
                homeOwnerCheck || user.roles[0].role.name === 'Occupant'
                  ? {}
                  : {
                      label: 'People',
                      count: counts.propertyDevelopersCount
                        ? counts.propertyDevelopersCount.toString()
                        : '0',
                      content: <PropertyDevelopers property={property} />,
                    },
                user &&
                (user.roles[0].role.name === 'Admin' ||
                  user.roles[0].role.name === 'Super Admin' ||
                  user.roles[0].role.name === 'Property Developer')
                  ? {
                      label: variables.conveyance,
                      content: (
                        <Empty
                          headline="Download CSV File"
                          strapline="Download a csv of the submitted legal/notary information from homeowners."
                          searchIsActive={''}
                          cta={
                            <>
                              <CSVLink
                                data={propertyCSV}
                                headers={headers}
                                filename={'Legal_Notary_Info.csv'}
                                className="button"
                                style={{
                                  backgroundColor: Colors.toggleAndButtonColor,
                                }}
                                target="_blank"
                              >
                                Download CSV File
                              </CSVLink>
                            </>
                          }
                          image={
                            <img
                              alt="No notes yet"
                              src="/assets/download_convaynance.png"
                            />
                          }
                        />
                      ),
                    }
                  : {},
              ]}
            />
          }
        />
      </PropertyRequestDataProvider>
    );
  }

  return <Loader />;
};

export default Property;
